<template>
    <div id="step-2" class="d-flex flex-column h-100 w-100">

        <div class="d-flex flex-column justify-content-start align-items-center w-100 mt-8 mt-md-12 mb-10">
            <div class="d-flex align-items-center justify-content-centers justify-content-start w-100">
                <span class="counter text-white mr-4" :class="`bg-${colour}`">2</span>
                <h3 class="text-white mb-0 text-uppercase">{{ config.heading }}</h3>
            </div>
        </div>

        <div class="row mb-6">
            <div ref="regionSelectDiv" id="region-select" class="col-md-5 offset-md-1 col-lg-5 col-xl-4 col-xxl-3 order-md-last">
                <select ref="regionSelect" v-on:change="(e) => selectRegion(e.target.value)"
                    :class="`${colour} selectpicker dropdown-chevron`" data-style="btn-light" data-width="100%">
                    <option value="">Select your region</option>
                        <!-- :data-subtext="region.attributes.name" -->
                    <option v-for="(region,index) in regions"
                        :value="region.id"
                        :data-content="getOptionHtml(region,index)"
                        :key="`regions-${index}`"
                        :selected="region.id == region_id">
                        {{ region.attributes.label }}
                    </option>
                </select>
                <p class="text-white border-top-white pt-3 mt-1 text-left" v-html="selectedRegionLabel"></p>
            </div>
            <div class="col-md-6 text-md-right">
                <img v-if="hovered" :src="_.imgPath(hoverImage)" :alt="`${selectedRegionLabel} map`" class="region-img">
                <img v-else-if="hasMap" :src="_.imgPath(mapImage)" :alt="`${selectedRegionLabel} map`" class="region-img">
                <img v-else src="/img/site/maps/regions-nz.svg" class="region-img" alt="NZ Regions">
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <button v-on:click="back()" class="btn btn-md btn-outline-white px-9_ mr-2"
                :class="`btn-outline-white__${colour}`">
                Back
            </button>
            <button v-on:click="forward()" :disabled="!isValid" class="btn btn-md"
                :class="[{ 'disabled': !isValid }, isValid ? `btn-${colour}` : `btn-outline-white btn-outline-white__${colour}` ]">
                Next
            </button>
        </div>

    </div>
</template>
<script>
import UtilsMixin from '../UtilsMixin';
export default {
    data() {

        const hybridType = window.localStorage.getItem('hybridType') ?? 'silage';
        const hybridRegion = window.localStorage.getItem(`${hybridType}Region`) ?? null;
        // const selectedRegion = JSON.parse(hybridRegion);

        return {
            regions: [],
            selectedRegion: [],
            // type: hybridType,
            region_id: hybridRegion,
            selectedSilageRegion: null,
            selectedGrainRegion: null,
            hovered: false,
            hoverImage: null,
        }
    },

    props: ['filters', 'config', 'value', 'type'],

    mixins: [UtilsMixin],

    mounted() {
        this.regions = _.get(this.filters[this.type], 'regions.data');

        // get region from local storage
        if(this.type == 'silage' && this.silageRegion) {
            this.region_id = this.silageRegion;
        }
        if(this.type == 'grain' && this.grainRegion) {
            this.region_id = this.grainRegion;
        }

        if(this.region_id) {
            this.selectRegion(this.region_id);
        }
        // if(this.region_id && this.type == 'grain') {
        //     this.selectedRegion = this.setGrainRegion(this.region_id);
        // }

        this.$nextTick(() => {
            initSelectpickers();
            $(this.$refs.regionSelect).selectpicker('refresh');

            // region select map hovers
            $(this.$refs.regionSelectDiv).on('mouseenter', '.dropdown-item', (e) => {
                let region_id = $(e.target).find('.label-hidden').attr('id');
                // console.log('region_id', region_id);
                if(!region_id) return;

                this.hoverImage = this.getHoverImage(region_id);
                this.hovered = true;
            });
            $(this.$refs.regionSelectDiv).on('mouseleave', '.dropdown-menu', (e) => {
                this.hovered = false;
                this.hoverImage = null;
            });
        });
    },

    watch: {
        silageRegion: {
            handler(newVal) {
                this.selectedSilageRegion = _.find(this.regions,  function(obj) {
                    return obj.id == newVal;
                });
            },
            immediate: true,
        },
        grainRegion: {
            handler(newVal) {
                this.selectedGrainRegion = _.find(this.regions,  function(obj) {
                    return obj.id == newVal;
                });
            },
            immediate: true,
        },
    },

    computed: {
        colour() {
            return this.type == 'silage' ? 'primary' : 'yellow';
        },
        isValid() {
            return !_.isEmpty(this.selectedRegion);
        },
        hasMap() {
            return !_.isEmpty(_.get(this.selectedRegion, 'attributes.map_image'));
        },
        mapImage() {
            return _.get(this.selectedRegion, 'attributes.map_image');
        },
        selectedRegionLabel() {
            return _.get(this.selectedRegion, 'attributes.name', 'Select your growing from the drop down above.');
        }
    },

    methods: {
        getOptionHtml(region,index) {
            return `${region.label} <small class="text-muted label-hidden" id="${region.id}">${region.attributes.name}</small>`;
        },
        getHoverImage(region_id){
            if(!region_id){
                return null;
            }
            let image = _.chain(this.regions)
                .find((o) => {
                    return o.id == region_id
                })
                .get('attributes.map_image', {})
                .value();

            return image;
        },
        selectRegion(region_id) {
            if(!region_id){
                return;
            }
            this.region_id = region_id;

            if(this.type == 'silage') {
                this.setSilageRegion(region_id);
            }
            if(this.type == 'grain') {
                this.setGrainRegion(region_id);
            }

            // this.selectedRegion = _.find(this.regions,  {'id' : region_id});
            this.selectedRegion = _.find(this.regions,  function(obj) {
                return obj.id == region_id;
            });

        },
        updateValue(option) {
            this.$emit('input', option);
        },
        back() {
            this.$emit('back');
        },
        forward() {
            if(!this.isValid){
                return false;
            }
            this.updateValue(this.selectedRegion);
            // this.$emit('forward');
        },
    },
}

</script>